import { useEffect } from "react";
import { X } from "lucide-react";

export default function RightDrawer({ open, onClose, title, description, children, footer, width = "max-w-lg", testid = "drawer" }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100]" data-testid={`${testid}-root`}>
      <div
        className="fixed inset-0 bg-[#111111]/50 animate-fade-in z-[90]"
        onClick={onClose}
        data-testid={`${testid}-overlay`}
      />
      <div
        className={`fixed inset-y-0 right-0 z-[100] w-full ${width} bg-white shadow-[0_8px_24px_rgba(17,17,17,0.16)] h-full flex flex-col animate-drawer-in`}
        role="dialog"
        data-testid={`${testid}-panel`}
      >
        <div className="flex items-start justify-between px-6 py-5 border-b border-[#EFEFEF] flex-shrink-0">
          <div className="flex items-start gap-3">
            <span className="w-1.5 h-10 bg-[#FFDA1A] rounded-full flex-shrink-0 mt-0.5" />
            <div>
              <h3 className="font-heading text-xl font-bold text-[#111111] tracking-tight">{title}</h3>
              {description && <p className="text-sm text-[#484848] mt-1">{description}</p>}
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-[#767676] hover:text-[#111111] hover:bg-[#F5F5F5] rounded-[4px] p-1.5 transition-colors"
            data-testid={`${testid}-close`}
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-5">{children}</div>
        {footer && (
          <div className="px-6 py-4 border-t border-[#EFEFEF] flex-shrink-0 bg-[#F5F5F5] flex items-center justify-end gap-3">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}
